import {
  type KeyOfType,
  getValueFromKeyOfType,
} from '../../../types/KeyOfType';
import type { TableColumnFormatLink } from '../../links/TableLink';
import type { TableColumnBase } from '../TableColumnBase';
import {
  type TableDataColumnConfig,
  pickTableColumnConfig,
} from '../TableColumnConfig';
import { formatValueToCsvString } from './helpers/formatValueToCsvString';

export type TableColumnFormatUrl<TRow> = {
  type: 'url';
  field: KeyOfType<TRow, string | string[] | null>;
  label?: string;
} & TableColumnFormatLink<TRow>;

type UrlColumnConfig<TRow, TDataType> = {
  label?: string;
} & TableDataColumnConfig<TRow, TDataType>;

export const createUrlColumn: {
  <TRow>(
    config: UrlColumnConfig<TRow, string | null> & { array?: false },
  ): TableColumnBase<TRow, TableColumnFormatUrl<TRow>>;
  <TRow>(
    config: UrlColumnConfig<TRow, string[] | null> & { array: true },
  ): TableColumnBase<TRow, TableColumnFormatUrl<TRow>>;
} = <TRow>(
  config: UrlColumnConfig<TRow, string | string[] | null>,
): TableColumnBase<TRow, TableColumnFormatUrl<TRow>> => ({
  ...pickTableColumnConfig(config),
  format: {
    type: 'url',
    field: config.key,
    label: config.label,
  },
  csvStringDependencies: [config.key],
  webDependencies: [config.key],
  toCsvString: (row) =>
    formatValueToCsvString(
      getValueFromKeyOfType<TRow, string | string[] | null>(row, config.key),
      (v: string | null): string => v ?? '',
    ),
  filter: config.filter ? config.filter : undefined,
});
